import {NameValueCodeDTO} from '../../../common/models/NameValueCodeDTO';
import {NameValueDTO} from '../../../common/models/NameValueDTO';
import {BaseDTO} from '../../../common/models/BaseDTO';

export class CoverageHistoryDTO extends BaseDTO {
    payer: NameValueCodeDTO;
    association: NameValueDTO;
    membershipNumber: string;
    startDate: Date;
    endDate: Date;
}
